import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ hasFullAccess, requiresFullAccess, element }) => {
  // If the route does NOT require full access, it's allowed.
  // OR if it DOES require full access AND the user has full access, it's allowed.
  if (!requiresFullAccess || hasFullAccess) {
    return element;
  }
  return <Navigate to="/subscribe" replace />;
};

export default ProtectedRoute;
